import './MatchSlot.css'

import { cx } from '../utilities/cx'

export type MatchSlotProps = {
  className?: string
  resetAt?: string
}

function calculateDaysUntil(dateString: string | undefined): number | null {
  if (!dateString) return null
  const resetDate = new Date(dateString)
  const now = new Date()
  const diffMs = resetDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
  return Math.max(0, diffDays)
}

export const MatchSlot = (props: MatchSlotProps) => {
  const { className, resetAt } = props

  const daysUntil = calculateDaysUntil(resetAt)

  return (
    <div className={cx('match-slot', className)}>
      <div className="match-slot__pattern">
        <div className="match-slot__pattern-inner" />
      </div>
      <div className="match-slot__content">
        <div className="match-slot__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        </div>
        <div className="match-slot__label">New match in</div>
        <div className="match-slot__countdown">
          {daysUntil !== null ? (
            <>
              <span className="match-slot__days">{daysUntil}</span>
              <span className="match-slot__unit">{daysUntil === 1 ? 'day' : 'days'}</span>
            </>
          ) : (
            <span className="match-slot__soon">Soon</span>
          )}
        </div>
      </div>
    </div>
  )
}
